export const shouldEnablePolicyBtn = (container) =>
  container &&
  container.getBoundingClientRect().bottom - window.innerHeight <= 0;
